import $ from 'jquery';

$(document).ready(function () {
    const $carousel = $('.news-slider2');
    const $carousel_hero = $('.hero__carousel-wrapper');

    if ($carousel) {

        $carousel.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            draggable: true,
            swipe: true,
            fade: false,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    if($carousel_hero) {
        $carousel_hero.slick({
            dots: true,
            infinite: true,
            draggable: true,
            arrows: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }
});